jQuery(document).ready(function onArchitectPopupReady($) {
	'use strict';

	$(document).scroll(onScroll);

	function onScroll() {
		var y = $(this).scrollTop();
		if (y > 200) {
			$('.architect-popup').fadeIn();
		} else {
			$('.architect-popup').fadeOut();
		}
	}
});
